var React = require('react');

function ArrowAltRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M16.26.27v5.64H0v6.24h16.26v5.64l8.76-8.76z"}));
}

ArrowAltRight.defaultProps = {"aria-hidden":"true","focusable":"false","role":"img","viewBox":"0 0 25 18"};

module.exports = ArrowAltRight;

ArrowAltRight.default = ArrowAltRight;
